export default "__VITE_ASSET__htjWz_lYTYTiga2u$BdEng__"